interface FAQItemProps {
  faq: {
    question: string;
    answer: string;
  };
  isOpen: boolean;
  onToggle: () => void;
}

export default function FAQItem({ faq, isOpen, onToggle }: FAQItemProps) {
  return (
    <div className="bg-background-50 border border-background-200/70 rounded-lg overflow-hidden">
      <button
        onClick={onToggle}
        className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-50/80 transition-colors"
      >
        <h3 className="font-heading font-medium text-foreground-950 text-sm pr-4">
          {faq.question}
        </h3>
        <div
          className={`w-5 h-5 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${
            isOpen ? 'rotate-45' : ''
          }`}
        >
          <i className="ri-add-line text-foreground-500 text-sm"></i>
        </div>
      </button>
      {isOpen && (
        <div className="px-5 pb-4">
          <p className="text-sm text-foreground-600 leading-relaxed">
            {faq.answer}
          </p>
        </div>
      )}
    </div>
  );
}